var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "list-group-item d-inline-flex align-items-center",
      class: _vm.preventAction
        ? "border-0 px-0 disabled"
        : "list-group-item-action",
      on: {
        click: function ($event) {
          return _setup.itemSelected(_vm.item)
        },
      },
    },
    [
      _vm.item.thumb
        ? _c(
            "div",
            {
              staticClass: "mr-3",
              staticStyle: { height: "50px", width: "50px" },
            },
            [
              _c("img", {
                staticClass: "img-thumbnail p-0 img-fluid h-100 w-100",
                attrs: { src: _setup.getThumbUrl(_vm.item.thumb), alt: "" },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "mr-auto" }, [_vm._v(_vm._s(_vm.item.name))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }